// extracted by mini-css-extract-plugin
module.exports = {"Img":"Image_Img__IV2Kj"};